import loadImage from './loadImage.js';
import preloadImages from './preloadImages.js';

export defa mx-1  ult {
  loadImage,
  preloadImages,
};
